import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { useIsInHomeEnabled } from "@src/appV2/redesign/InHome/lib/useIsInHomeEnabled";
import { useWorkerPendingVisitInvites } from "@src/appV2/redesign/InHome/VisitInvites/api/useWorkerPendingVisitInvites";
import { useWorkerPendingShiftInvites } from "@src/appV2/redesign/WorkerShifts/ShiftInvites/api/useWorkerPendingShiftInvites";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useCallback } from "react";

import { InviteRequiredPageContent } from "./PageContent";

export function InviteRequiredPage() {
  const { userId } = useDefinedWorker();
  const { data: { clipboardScore = 0 } = {}, refetch: refetchClipboardScoreProfile } =
    useGetClipboardScoreProfile(userId);
  const { data: { data: shiftInvites } = {}, refetch: refetchShiftInvites } =
    useWorkerPendingShiftInvites();

  const isInHomeEnabled = useIsInHomeEnabled();
  const { data: visitInvitesData, refetch: refetchVisitInvites } = useWorkerPendingVisitInvites({
    options: {
      enabled: isInHomeEnabled,
    },
  });

  const invitesCount = (shiftInvites?.length ?? 0) + (visitInvitesData?.data?.length ?? 0);

  const refreshAllData = useCallback(async () => {
    const promises: Promise<unknown>[] = [refetchClipboardScoreProfile(), refetchShiftInvites()];
    if (isInHomeEnabled) {
      promises.push(refetchVisitInvites());
    }
    await Promise.all(promises);
  }, [isInHomeEnabled, refetchClipboardScoreProfile, refetchShiftInvites, refetchVisitInvites]);

  return (
    <InviteRequiredPageContent
      clipboardScore={clipboardScore}
      invitesCount={invitesCount}
      onRefresh={refreshAllData}
    />
  );
}
